import Header from "./components/Global/Header";
import { useLayout } from "./contexts/LayoutContent";
import Routes from "./routes";
import { StyledBody } from "./styles/body";
import Global from "./styles/global";

function App() {
	const { darkMode } = useLayout();

	return (
		<div className="App">
			<Global darkMode={darkMode} />
			<Header />
				<Routes />
		</div>
	);
}

export default App;
